import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from 'fronton-react';
import { checkScreenType } from 'utils';
import { selectWindowType, WindowTypes } from '../../../../../store/pageStore';
import { StepsContainer, Header, StepNumber, StepsTitle } from './styles';

type StepsProps = {
	title: string;
	categoryPhotoUrl: string;
	listItems: string[];
	className?: string;
};

export const Steps = memo(({ title, categoryPhotoUrl, listItems, className }: StepsProps) => {
	const screenType = useSelector(selectWindowType);
	const isTablet = checkScreenType(screenType, WindowTypes.tablet);
	const headingVariant = useMemo(() => (isTablet ? 'l' : 'm'), [isTablet]);

	return (
		<StepsContainer className={className} data-qa="steps">
			<Header>
				<StepsTitle variant={headingVariant} size="body_accent" data-qa="steps-title">
					{title}
				</StepsTitle>
				<img src={categoryPhotoUrl} alt="Порядок оказания Услуги" data-qa="steps-img" />
			</Header>
			<ol>
				{listItems.map((item, key) => (
					<li key={`step-${item}`} data-qa="steps-item">
						<StepNumber>
							<Typography variant="caption_accent">{key + 1}</Typography>
						</StepNumber>
						<Typography variant="s" size="body_long">
							{item}
						</Typography>
					</li>
				))}
			</ol>
		</StepsContainer>
	);
});
